/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_NeverInputs */



/**
* | output |
* | --- |
* | "not run yet" |
*
* @param {Admin_Status_NeverInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_never = /** @type {((inputs?: Admin_Status_NeverInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_NeverInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("jamais exécuté")
	if (locale === "es") return /** @type {LocalizedString} */ ("no ejecutado aún")
	if (locale === "pt") return /** @type {LocalizedString} */ ("ainda não executado")
	if (locale === "it") return /** @type {LocalizedString} */ ("non ancora eseguito")
	return /** @type {LocalizedString} */ ("not run yet")
});